export default __webpack_public_path__ + "static/media/mary.a6f8a16e.PNG";